import { TaskType } from '@abstract-trainer/config'
import type {
  TrainerTask,
  TrainerTaskLocalAnswer,
  TrainerTaskRemoteData
} from '@abstract-trainer/services/types'
import { markRaw, type Component, type UnwrapRef } from 'vue'
import type TrainerTaskAnswer from '../TrainerTaskAnswer'
import AbstractTrainerTask from './AbstractTrainerTask'
import VideoCallTrainerTask from '@abstract-trainer/components/TrainerTask/TrainerTaskTypeComponents/VideoCallTrainerTask/VideoCallTrainerTask.vue'

export default class TrainerTaskVideoCall extends AbstractTrainerTask {
  type: TaskType.VideoCall
  data: null
  component: Component

  constructor(data: TrainerTaskRemoteData) {
    super(data)

    if (data.test_type !== TaskType.VideoCall) {
      throw new Error(`Wrong Trainer Type: ${data.test_type}`)
    }

    this.type = data.test_type
    this.data = null

    this.component = markRaw(VideoCallTrainerTask)
  }

  getOptionsWithValidatedStatus(): [] {
    return []
  }

  getLocalAnswer<T extends TrainerTask>(answer: TrainerTaskAnswer | null) {
    return null as UnwrapRef<TrainerTaskLocalAnswer<T>>
  }

  hasLocalAnswer(): boolean {
    return true // чтобы кнопка "Ответить" была активна
  }

  isAnswerModified(): boolean {
    return true
  }

  hasRemoteAnswer(answer: TrainerTaskAnswer | null): boolean {
    return !!answer?.id || !!answer?.answer || !!answer?.isVideoCallCompleted
  }
}
